// auth0Client.ts
import { Auth0Client } from '@auth0/auth0-spa-js'

const auth0Client = new Auth0Client({
  domain: import.meta.env.VITE_AUTH_DOMAIN!,
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID!,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://auth.neatolabs.io/',
  },
})

export default auth0Client
